import styled from 'styled-components';
import { mixins } from '@jarvis/react-portal-addons';
import primitives from '@veneer/primitives';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${primitives.layout.size4}px;
  z-index: 1;
  max-width: 1588px;
  padding-bottom: ${primitives.layout.size4}px;

  ${mixins.veneer.md(`
    gap: ${primitives.layout.size5}px;
  `)}

  ${mixins.veneer.lg(`
    gap: ${primitives.layout.size6}px;
    padding: ${primitives.layout.size6}px ${primitives.layout.size8}px;
  `)}

  ${mixins.veneer.xl(`
    margin: auto;
    padding: ${primitives.layout.size7}px 36px;
    gap: ${primitives.layout.size6}px;
  `)}

  ${mixins.veneer.xxl(`
    gap: ${primitives.layout.size7}px;
  `)}
`;

export const Grid = styled.div`
  display: grid;
  gap: ${primitives.layout.size4}px;
  grid-template-columns: repeat(12, 1fr);
  position: relative;
  max-width: 1660px; // 1920 is the max content width (side menu + content area), side menu is 260px.
  z-index: 1;
  padding: 0 ${primitives.layout.size4}px;

  ${mixins.veneer.md(`
    gap: ${primitives.layout.size5}px;
    padding: 0 ${primitives.layout.size7}px;
  `)}

  ${mixins.veneer.lg(`
    gap: ${primitives.layout.size6}px;
    padding: unset;
  `)}

  ${mixins.veneer.xl(`
    gap: ${primitives.layout.size7}px;
  `)}
`;

export const PrintAnywhereContainer = styled.div`
  grid-column: 1 / span 12;
  align-self: stretch;

  ${mixins.veneer.xl(`
    grid-column: 1 / span 8;
  `)}
`;

export const PrivatePickupContainer = styled.div`
  grid-column: 1 / span 12;

  align-self: stretch;
  display: flex;
  justify-content: center;
  ${mixins.veneer.xl(`
    justify-content: flex-start;
    grid-column: 1 / span 8;
  `)}
`;

export const SideCardsContainer = styled.div`
  grid-column: 1 / span 12;

  align-self: stretch;
  display: flex;
  gap: ${primitives.layout.size6}px;
  flex-direction: column;
  grid-column: span 12;

  ${({ fullWidth }) => mixins.veneer.xl(`
    flex-direction: column;
    justify-content: flex-start;
    grid-column: ${fullWidth ? '1 / span 12' : '-5 / -1'};
  `)}

  ${mixins.veneer.xxl(`
    gap: ${primitives.layout.size7}px;
  `)}
`;
